import { render, staticRenderFns } from "./dialog_yiliao.vue?vue&type=template&id=0bdfb9da&scoped=true&"
import script from "./dialog_yiliao.vue?vue&type=script&lang=js&"
export * from "./dialog_yiliao.vue?vue&type=script&lang=js&"
import style0 from "./dialog_yiliao.vue?vue&type=style&index=0&id=0bdfb9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdfb9da",
  null
  
)

export default component.exports